import { motion } from 'framer-motion';

export default function ProgressBar({ current, total }) {
  const percentage = Math.round((current / total) * 100);

  return (
    <div className="fixed top-0 left-0 right-0 w-full z-50">
      <div className="w-full h-2 bg-gray-200">
        <motion.div
          className="h-full bg-onyx-green"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.3 }}
        />
      </div>
    </div>
  );
}
